/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { SpecialRequestHeader } from "./SpecialRequestHeader";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum Http_methodEnum {
  "GET" = "GET",

  "POST" = "POST",

  "PUT" = "PUT",

  "DELETE" = "DELETE",

  "PATCH" = "PATCH",

  "OPTIONS" = "OPTIONS",

  "TRACE" = "TRACE"
}

/**
 * The mock resource main info.
 */

// required attributes
const MockResourceReducedR = t.interface({
  tags: t.readonlyArray(t.string, "array of string"),

  http_method: enumType<Http_methodEnum>(Http_methodEnum, "http_method"),

  is_active: t.boolean,

  name: t.string,

  subsystem: t.string
});

// optional attributes
const MockResourceReducedO = t.partial({
  id: t.string,

  resource_url: t.string,

  special_headers: t.readonlyArray(
    SpecialRequestHeader,
    "array of SpecialRequestHeader"
  )
});

export const MockResourceReduced = t.intersection(
  [MockResourceReducedR, MockResourceReducedO],
  "MockResourceReduced"
);

export type MockResourceReduced = t.TypeOf<typeof MockResourceReduced>;
